export var MILLISECONDS_IN_DAY = 86400000;